import {AbstractParameter, IntegerParameter} from 'parameters/AbstractParameter.js';

class FilterEnvelope {
    constructor(synth, store, mixSession, context) {
        this.synth = synth;
        this.store = store;
        this.mixSession = mixSession;
        this.context = context;

        this.parameters = [];
        this.setupParameters();
    }

    onNewSynth(synth) {
        this.synth = synth;
        this.refreshParameters();
    }

    get attack() {
        return this.attackParameter.get();
    }

    set attack(x) {
        this.attackParameter.set(x);
    }

    get decay() {
        return this.decayParameter.get();
    }

    set decay(x) {
        this.decayParameter.set(x);
    }

    get sustain() {
        return this.sustainParameter.get();
    }

    set sustain(x) {
        this.sustainParameter.set(x);
    }

    get release() {
        return this.releaseParameter.get();
    }

    set release(x) {
        this.releaseParameter.set(x);
    }

    get baseFrequency() {
        return this.baseFrequencyParameter.get();
    }

    set baseFrequency(x) {
        this.baseFrequencyParameter.set(x);
    }

    get octaves() {
        return this.octavesParameter.get();
    }

    set octaves(x) {
        this.octavesParameter.set(x);
    }

    refreshParameters() {
        this.baseFrequency = this.baseFrequency;
        this.octaves = this.octaves;
        this.attack = this.attack;
        this.decay = this.decay;
        this.sustain = this.sustain;
        this.release = this.release;
    }

    setupParameters() {
        this.attackParameter = new AbstractParameter(
            'Filter Envelope Attack',
            this, (o, x) => o.synth.set({
                "filterEnvelope": {
                    "attack": x / 1000.0,
                },
            }),
            {
                min: 0,
                max: 10000,
                unit: 'ms',
                defaultValue: 60
            });

        this.registerParameter(this.attackParameter);

        this.decayParameter = new AbstractParameter(
            'Filter Envelope Decay',
            this, (o, x) => o.synth.set({
                "filterEnvelope": {
                    "decay":  x / 1000.0
                },
            }),
            {
                min: 0,
                max: 1,
                unit: 'ms',
                defaultValue: 60
            });

        this.registerParameter(this.decayParameter);

        this.sustainParameter = new AbstractParameter(
            'Filter Envelope Sustain',
            this, (o, x) => o.synth.set({
                "filterEnvelope": {
                    "sustain": x
                },
            }),
            {
                min: 0,
                max: 1,
                unit: '',
                defaultValue: 0.9
            });

        this.registerParameter(this.sustainParameter);

        this.releaseParameter = new AbstractParameter(
            'Filter Envelope Release',
            this, (o, x) => o.synth.set({
                "filterEnvelope": {
                    "release": x / 1000.0,
                },
            }),
            {
                min: 0,
                max: 1,
                unit: 'ms',
                defaultValue: 60
            });

        this.registerParameter(this.releaseParameter);

        this.baseFrequencyParameter = new IntegerParameter(
            'Filter Envelope Base Frequency',
            this, (o, x) => o.synth.set({
                "filterEnvelope": {
                    "baseFrequency": x
                },
            }),
            {
                min: 0,
                max: 10000,
                unit: 'HZ',
                defaultValue: 100
            });

        this.registerParameter(this.baseFrequencyParameter);

        this.octavesParameter = new IntegerParameter(
            'Filter Envelope Octaves',
            this, (o, x) => o.synth.set({
                "filterEnvelope": {
                    "octaves": x
                },
            }),
            {
                min: 0,
                max: 10,
                unit: '',
                defaultValue: 1
            });

        this.registerParameter(this.octavesParameter);
    }

    registerParameter(parameter) {
        parameter.setStore(this.store);
        parameter.setMixSession(this.mixSession);
        parameter.setContext(this.context);
        this.parameters.push(parameter);
    }

    copyFrom(filterEnvelope) {
        this.attack = filterEnvelope.attack;
        this.decay = filterEnvelope.decay;
        this.sustain = filterEnvelope.sustain;
        this.release = filterEnvelope.release;
        this.baseFrequency = filterEnvelope.baseFrequency;
        this.octaves = filterEnvelope.octaves;
    }

    getJson() {
        return {
            baseFrequency: this.baseFrequency,
            octaves: this.octaves,
            attack: this.attack,
            decay: this.decay,
            sustain: this.sustain,
            release: this.release
        };
    }

    fromJson(json) {
        if ('baseFrequency' in json) {
            this.baseFrequency = json.baseFrequency;
        }
        if ('octaves' in json) {
            this.octaves = json.octaves;
        }
        if ('attack' in json) {
            this.attack = json.attack;
        }
        if ('decay' in json) {
            this.decay = json.decay;
        }
        if ('sustain' in json) {
            this.sustain = json.sustain;
        }
        if ('releease' in json) {
            this.release = json.release;
        }
    }
}

export default FilterEnvelope;
